import { useState } from 'react';
import { InformationCircleIcon } from '@heroicons/react/24/outline';
import PropTypes from 'prop-types';

import PricingModal, { getPricingCopyVariant, PRICING_COPY_VARIANTS } from 'features/shop/PricingModal';
import { getPercentOffOriginalPrice, getProductOriginalPrice, getShowOriginalPrice } from 'utils/productUtils';

function ProductPrice({ productData }) {
    const [showPricingModal, setShowPricingModal] = useState(false);

    const originalPrice = getProductOriginalPrice(productData);
    const percentOffOriginalPrice = getPercentOffOriginalPrice(productData);
    const showOriginalPrice = getShowOriginalPrice(productData);

    const pricingCopyVariant = getPricingCopyVariant({
        brand: productData.brand,
        l1TaxonomyName: productData.l1TaxonomyName,
    });

    return (
        <>
            <div
                className="text-body-sm my-10 flex items-baseline"
                data-optimizely-id="acq-pdp-original-price-and-percent-off"
            >
                <p className="mr-5 font-grotesk-bold" data-optimizely-id="acq-pdp-final-price">
                    ${productData.price.toFixed(2)}
                </p>
                {showOriginalPrice && (
                    <>
                        <p
                            className="mr-5 line-through"
                            data-optimizely-id="acq-pdp-original-price"
                            data-testid="original-price"
                        >
                            ${originalPrice.toFixed(2)}
                        </p>
                        <p className="flex gap-5" data-optimizely-id="acq-pdp-percent-off">
                            {`${percentOffOriginalPrice}% OFF GROCERY STORE PRICES*`}
                            {PRICING_COPY_VARIANTS.includes(pricingCopyVariant) && (
                                <button
                                    type="button"
                                    onClick={() => {
                                        setShowPricingModal(true);
                                    }}
                                    aria-label="How is this calculated?"
                                >
                                    <InformationCircleIcon className="w-20" />
                                </button>
                            )}
                        </p>
                    </>
                )}
            </div>
            {showPricingModal && (
                <PricingModal open={showPricingModal} setOpen={setShowPricingModal} copyVariant={pricingCopyVariant} />
            )}
        </>
    );
}

ProductPrice.propTypes = {
    productData: PropTypes.shape({
        brand: PropTypes.string.isRequired,
        l1TaxonomyName: PropTypes.string.isRequired,
        msrp: PropTypes.number.isRequired,
        price: PropTypes.number.isRequired,
    }).isRequired,
};

export default ProductPrice;
